import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { PainSection } from '../components/PainSection';
import { TruthSection } from '../components/TruthSection';
import { ProductPresentation } from '../components/ProductPresentation';
import { ContentBreakdown } from '../components/ContentBreakdown';
import { BenefitsSection } from '../components/BenefitsSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { ForYouSection } from '../components/ForYouSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { ImpactPhrases } from '../components/ImpactPhrases';
import { Footer } from '../components/Footer';
export function SalesPage() {
  return <div className="min-h-screen bg-[#FFF8F0] font-sans selection:bg-[#FFCC80] selection:text-gray-900" data-id="element-380">
      <HeroSection data-id="element-381" />
      <PainSection data-id="element-382" />
      <TruthSection data-id="element-383" />
      <ProductPresentation data-id="element-384" />
      <ContentBreakdown data-id="element-385" />
      <BenefitsSection data-id="element-386" />
      <TestimonialsSection data-id="element-387" />
      <ForYouSection data-id="element-388" />
      <GuaranteeSection data-id="element-389" />
      <ValueStack data-id="element-390" />
      <FAQSection data-id="element-391" />
      <ImpactPhrases data-id="element-392" />
      <Footer data-id="element-393" />
    </div>;
}